import {Component, OnInit, Output, EventEmitter, Input, OnChanges} from '@angular/core';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import { UntypedFormArray, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {FormBuilderService, RateService, PricingOutput, TypesService, SalesService} from '../../../services';
import {InvidualInsuranceModel, SingleSplitLoanAmountModel} from '../../../models/widgets/single-split-loan-amount-model';
import {LCA_ORIGINATOR_PARTY_ROLE_ID} from '../../../_global/wiz.constants';
import * as _ from 'lodash';
import * as moment from 'moment';
import {debounceTime, take} from 'rxjs/operators';
import {DataHandlerService} from '../../../services/data-handler.service';
import { InsuranceDetailsComponent } from '../insurance-details/insurance-details.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgIf } from '@angular/common';
import { ValidationPartialComponent } from '../partials';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { CustomAsyncValidator } from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/common';

@Component({
    selector: 'app-single-split-loan-amount',
    templateUrl: './single-split-loan-amount.component.html',
    styles: [],
    standalone: true,
    imports: [MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatFormFieldModule, MatInputModule, MatInputModule, ValidationPartialComponent, NgIf, MatCheckboxModule, MatCheckboxModule, InsuranceDetailsComponent]
})
export class SingleSplitLoanAmountComponent extends WizardWidgetComponent implements OnInit, OnChanges {
  @Input() public formGroup: any;
  @Input() public insuranceList: any;
  @Input() public hasSettlement: any;
  @Input() public originator: any;
  @Input() public isGreen = false;
  @Input() public selectedVehicle: any;
  @Input() public loanPurpose: any;
  @Input() public productCategory: any;
  @Input() public originationFeeValidationSwitch = false;
  @Output() public purchaseAmountChange = new EventEmitter<any>();

  public dialDownEnabled = true; // IMPT - FLAG to return back implementation of dial down UI
  public totalLoanAmount = 0;
  public maxBrokeragePercent = 0;
  public hideBrokerage = false;
  public insurancesFormArray: any;
  public allInsurances: any;
  public updateOriginationFeeValidatorPayload: any = null;
  public showAddInsurance = false;
  public vehicleAge: number = null;
  private _subtotal = 0;
  private _totalFees = 0;
  private _totalInsurance = 0;
  private _brokerageUpdated = false;
  public lcaPartyRoleId = LCA_ORIGINATOR_PARTY_ROLE_ID;
  public lcaOriginator = false;
  public vehicleType: string;
  public channel: string;
  public rateData: PricingOutput;
  public feeTypes: any = [];

  constructor(private formBuilderService: FormBuilderService,
              public dataHandlerService: DataHandlerService,
              private rateService: RateService,
              private salesService: SalesService,
              public typesService: TypesService,
              private customAsyncValidator: CustomAsyncValidator,) {
    super(dataHandlerService);
  }

  async ngOnInit() {
    console.log('formGroup', this.formGroup);

    super.ngOnInit();

    this.dataHandlerService.getDialDownDisabledFlag().subscribe((res) => {
      if (!res) {
        this.dialDownEnabled = true;
        this.formGroup.get('brokerageFeeCapitalizedCheck').enable();
        this.formGroup.get('brokerageFeeCapitalizedCheck').patchValue(false);
        this.toggleDialDown(false);
      } else {
        this.formGroup.get('brokerageFeeCapitalizedCheck').disable();
        this.formGroup.get('brokerageFeeCapitalizedCheck').patchValue(false);
        this.toggleDialDown(false);
        this.getDialDownFlag();
      }
    });

    this.dataHandlerService.getVehicleType().subscribe((result: any) => {
      console.log('getVehicleType', result);
      if (result && result !== this.vehicleType) {
        this.vehicleType = result;
        this.checkValidation();
      }
    });

    this.dataHandlerService.getBidCompliantFlag().subscribe((result: any) => {
      this.hideBrokerage = !!(result);
      if (result) {
        this.formGroup.get('brokerageFeeCheck').patchValue(true);
        this.toggleBrokerageFees(true);
      }
    });

    this.dataHandlerService.getApplicationFee()
      .subscribe((result: any) => {
        if (result && result.amount) {
          this.formGroup.get('applicationFee').patchValue(result.amount, {emitEvent: false});
        }
      });

    this.typesService.getTypesList('fee-types')
      .then((results) => {
        this.feeTypes = results;
      });

    this.initInsurance();
    this.initSubscriptions();
    this.calculateSubtotal();

    // console.log('originator', this.originator);
    this.checkOriginator();
    this.checkOrigBrokerFees();
    this.checkValidation();
    this.checkApplicationFee();
  }

  async getDialDownFlag() {
    return this.rateService.getDialDownEnabled().then((res) => {
      // check first the value of brokerage capitalization
      if (this.formGroup.value.brokerageFeeCapitalizedCheck !== null ||
        this.formGroup.value.brokerageFeeCapitalizedCheck !== undefined) {
        this.dialDownEnabled = !this.formGroup.value.brokerageFeeCapitalizedCheck;
      } else {
        // use the default
        this.dialDownEnabled = res;
      }
      this.toggleRateParameters();
    });
  }

  toggleDialDown(dialDownDisabled) {
    this.dialDownEnabled = !dialDownDisabled;
    this.toggleRateParameters();
  }

  toggleRateParameters() {
    this.rateService.setRateParameters({brokeragePaymentType: (this.dialDownEnabled) ? 'paid-by-funder' : 'funded'});
    this.updateMaxBrokerageAmount();
  }

  ngOnChanges(changes) {
    this.insurancesFormArray = <UntypedFormArray>this.formGroup.controls['insurances'];

    if (changes['formGroup'] && changes['formGroup']['firstChange']) {
      this.purchaseAmountChange.emit(changes['formGroup']['currentValue']['value']['purchaseRefinanceAmount']);
    }

    if (changes['insuranceList']) {
      this.allInsurances = changes['insuranceList']['currentValue'];
    }

    if (changes['loanPurpose']) {
      this.checkApplicationFee();
    }

    this.checkValidation();
    this.checkOriginator();
    this.checkOrigBrokerFees();

    if (changes['isGreen']) {
      this.checkValidation();
    }
  }

  checkValidation() {
    console.log('checkValidation', this.selectedVehicle, this.vehicleType);

    const maxLoanAmount = (this.vehicleType && this.vehicleType === 'caravan') ? 100000 : 150000;
    this.formGroup.get('totalLoanAmount').clearValidators();
    this.formGroup.get('totalLoanAmount').setValidators([Validators.required, Validators.min(5000), Validators.max(maxLoanAmount)]);
    this.formGroup.get('totalLoanAmount').updateValueAndValidity();

    if (!this.isGreen) {
      const comparisonYear: number = +(moment().format('YYYY'));
      this.vehicleAge = this.selectedVehicle ? Math.abs(comparisonYear - this.selectedVehicle.year) : null;

      if (this.vehicleAge > 7) {
        console.log('vehicle is 7 years or older');
        this.formGroup.get('totalLoanAmount').setValidators([Validators.min(5000), Validators.max(50000)]);
        this.formGroup.get('totalLoanAmount').updateValueAndValidity();
      }
    }

    console.log('originationFeeValidationSwitch', this.originationFeeValidationSwitch);
    if (this.originationFeeValidationSwitch) {
      // @todo: keep after deployment of FITS-3133
      this.dataHandlerService.getOriginatorChannel()
        .pipe(take(1))
        .subscribe((channel: any) => {
          console.log('getOriginatorChannel', channel);
          this.channel = channel;

          this.updateOriginationFeeValidator(channel);

          // Subscribe to value changes for the relevant form controls and update the async validator
          this.formGroup.get('totalLoanAmount').valueChanges.subscribe(() => this.updateOriginationFeeValidator(channel));
          this.formGroup.get('originationFee').valueChanges
            .subscribe((data) => {
              this.updateOriginationFeeValidator(channel); // Re-run validation when originationFee changes
            });
        });
    } else {
      // @todo: remove after deployment of FITS-3133
      this.formGroup.get('originationFee').setValidators(Validators.compose([
        Validators.max(1210),
        Validators.pattern('[0-9.]*'),
        Validators.min(1),
        Validators.required
      ]));
      this.formGroup.get('originationFee').updateValueAndValidity();
    }

    console.log('originationFee', this.formGroup.get('originationFee'));
  }

  updateOriginationFeeValidator(channel: any) {
    const opts = {
      amount: +(this.formGroup.get('totalLoanAmount')?.value),
      fee: +(this.formGroup.get('originationFee').value),
      purpose: this.loanPurpose,
      channel,
      productCategoryType: this.productCategory,
    };

    // prevent unnecessary api and validation checks
    if (!_.isEqual(opts, this.updateOriginationFeeValidatorPayload)) {
      this.updateOriginationFeeValidatorPayload = opts;
      console.log('updateOriginationFeeValidator', opts);

      this.formGroup.get('originationFee').setAsyncValidators(this.customAsyncValidator.fmcFeeValidator.bind(this.customAsyncValidator, { value: opts }, 'origination'));
      this.formGroup.get('originationFee').updateValueAndValidity({
        onlySelf: true,
        emitEvent: false,
      });

      console.log('originationFee:formGroup', this.formGroup.get('originationFee'));
    }
  }

  checkApplicationFee() {
    this.dataHandlerService.getOriginatorChannel()
      .pipe(take(1))
      .subscribe((data: any) => {
        this.channel = data;

        const payload: any = {
          productCategoryType: 'motor-vehicle-loan',
          purpose: this.loanPurpose,
          channel: data
        };

        if (payload.purpose && payload.channel) {
          this.salesService.getFeeTypeConfiguration('application', payload)
            .subscribe({
              next: (fee: any) => {
                if (fee && fee.amount) {
                  this.dataHandlerService.setApplicationFee(fee);
                  this.calculateSubtotalAndFees();
                }
              },
              error: (err: any) => {
                console.log('error', err);
              },
              complete: () => {
                console.log('complete');
              }
            });
        }
      });
  }

  checkOriginator() {
    if (this.originator && this.originator.id === this.lcaPartyRoleId) {
      this.lcaOriginator = true;
      this.lcaFormValidationUpdate();
    } else {
      this.lcaOriginator = false;
    }
  }

  initSubscriptions() {
    this.formGroup.get('purchaseRefinanceAmount').valueChanges
      .pipe(debounceTime(500))
      .subscribe(val => {
          console.debug('SingleSplitLoanAmountComponent.initSubscriptions.purchaseRefinanceAmount');
          this.purchaseAmountChange.emit(val);
          this.calculateSubtotal();
          this.calculateBrokerage('brokerageFee');
        }
      );

    this.formGroup.get('purchaseRefinanceAmount').valueChanges
      .pipe(debounceTime(500))
      .subscribe(val => {
          console.debug('SingleSplitLoanAmountComponent.initSubscriptions.purchaseRefinanceAmount');
          this.purchaseAmountChange.emit(val);
          this.calculateSubtotal();
        }
      );

    this.formGroup.get('depositTradeAmount').valueChanges
      .pipe(debounceTime(500))
      .subscribe(val => {
          console.debug('SingleSplitLoanAmountComponent.initSubscriptions.depositTradeAmount');
          this.calculateSubtotal();
        }
      );

    this.formGroup.get('amountPaid').valueChanges
      .subscribe(
        val => {
          console.debug('SingleSplitLoanAmountComponent.initSubscriptions.amountPaid');
          this.calculateSubtotal();
        }
      );

    this.formGroup.get('originationFee').valueChanges
      .subscribe(val => {
          console.debug('SingleSplitLoanAmountComponent.initSubscriptions.originationFee');
          this.calculateSubtotalAndFees();
        }
      );

    this.formGroup.get('brokerageFeePercentage').valueChanges
      .pipe(debounceTime(1500))
      .subscribe(
        val => {
          console.debug('SingleSplitLoanAmountComponent.initSubscriptions.brokerageFeePercentage');
          if (!this._brokerageUpdated) {
            this.calculateBrokerage('brokerageFeePercentage');
          } else {
            this._brokerageUpdated = false;
          }
        }
      );

    this.formGroup.get('brokerageFee').valueChanges
      .pipe(debounceTime(1500))
      .subscribe(
        val => {
          console.debug('SingleSplitLoanAmountComponent.initSubscriptions.brokerageFee');
          if (!this._brokerageUpdated) {
            this.calculateBrokerage('brokerageFee');
          } else {
            this._brokerageUpdated = false;
          }
        }
      );

    this.rateService.rateData.subscribe((val) => {
      console.debug('SingleSplitLoanAmountComponent.rateService.rateData');
      if (val && !this.lcaOriginator) { // no need to add brokerageFee validation since this is an lca originator
        this.rateData = val;
        this.toggleBrokerageFees(this.formGroup.value.brokerageFeeCheck);
      }
    });
  }

  updateMaxBrokerageAmount() {
    const max = _.get(this.rateData, 'MaxBrokerageAmountAvailable');

    if (!isNaN(max) && Number(max) && !this.formGroup.value.brokerageFeeCheck) {
      this.formGroup.get('brokerageFeePercentage').clearValidators();
      this.formGroup.get('brokerageFee').setValidators([Validators.min(1), Validators.required, Validators.max(Number(max))]);

      const brokerageFeeType = this.feeTypes.find(x => x.id === 'brokerage');
      if (brokerageFeeType && brokerageFeeType.ext.maxVehicleBrokeragePercent) {
        this.maxBrokeragePercent = +(brokerageFeeType.ext.maxVehicleBrokeragePercent) * 100;
      }
    } else {
      this.formGroup.get('brokerageFee').setValidators([Validators.min(1), Validators.required]);
    }
    this.formGroup.get('brokerageFee').updateValueAndValidity({emitEvent: false});
    this.formGroup.get('brokerageFeePercentage').updateValueAndValidity({emitEvent: false});
  }

  lcaFormValidationUpdate() {
    this.formGroup.get('brokerageFee').clearValidators();
    this.formGroup.get('brokerageFee').updateValueAndValidity();
    this.formGroup.get('brokerageFeeCheck').patchValue(true);

    this.formGroup.get('originationFeeCheck').patchValue(true);
    this.formGroup.get('originationFee').clearValidators();
    this.formGroup.get('originationFee').updateValueAndValidity();
  }

  checkOrigBrokerFees() {
    this.toggleOriginatorFee(this.formGroup.get('originationFeeCheck').value);
    this.toggleBrokerageFees(this.formGroup.get('brokerageFeeCheck').value);
  }

  toggleBrokerageFees(value) {
    if (value) {
      this.formGroup.get('brokerageFeePercentage').clearValidators();
      this.formGroup.get('brokerageFeePercentage').patchValue(0);
      this.formGroup.get('brokerageFeePercentage').disable();
      this.formGroup.get('brokerageFeePercentage').updateValueAndValidity();
      this.formGroup.get('brokerageFee').patchValue(0);
      this.formGroup.get('brokerageFee').disable();
      this.formGroup.get('brokerageFee').clearValidators();
      this.formGroup.get('brokerageFee').updateValueAndValidity();
    } else {
      this.formGroup.get('brokerageFee').enable();
      this.formGroup.get('brokerageFee').updateValueAndValidity();
      this.formGroup.get('brokerageFeePercentage').enable();
      this.formGroup.get('brokerageFeePercentage').updateValueAndValidity();
      this.updateMaxBrokerageAmount();
    }
  }

  toggleOriginatorFee(value) {
    if (value) {
      this.formGroup.get('originationFee').clearValidators();
      this.formGroup.get('originationFee').updateValueAndValidity();
      this.formGroup.get('originationFee').patchValue(0);
      this.formGroup.get('originationFee').disable();
    } else {
      if (this.originationFeeValidationSwitch) {
        // @todo: keep after deployment of FITS-3133
        this.formGroup.get('originationFee').enable();
        this.formGroup.get('originationFee').setValidators(new SingleSplitLoanAmountModel().originationFee.validation);
        this.updateOriginationFeeValidator(this.channel);
        this.formGroup.get('originationFee').updateValueAndValidity();
      } else {
        // @todo: remove after deployment of FITS-3133
        this.formGroup.get('originationFee').enable();
        this.formGroup.get('originationFee').setValidators(new SingleSplitLoanAmountModel().originationFee.validation);
        this.formGroup.get('originationFee').updateValueAndValidity();
      }
    }

    console.log('toggleOriginatorFee', this.formGroup.get('originationFee'));
  }

  calculateSubtotal() {
    this._subtotal = +(this.formGroup.get('purchaseRefinanceAmount').value
      - this.formGroup.get('depositTradeAmount').value
      - this.formGroup.get('amountPaid').value).toFixed(2);
    this.formGroup.get('subTotal').patchValue(this._subtotal);

    this.calculateSubtotalAndFees();
  }

  calculateSubtotalAndFees() {
    this._totalFees = +(this.formGroup.get('applicationFee').value) + +(this.formGroup.get('originationFee').value) + +(this._totalInsurance).toFixed(2);
    this.formGroup.get('subtotalWithFees').patchValue(this._subtotal + this._totalFees);

    // validate if sum of insurances don't exceed 10% of purchase price
    const ratio = (this._totalInsurance / this.formGroup.get('purchaseRefinanceAmount').value) * 100;
    if (ratio > 10) {
      this.formGroup.get('subtotalWithFees').setErrors({'invalid': true});
    } else {
      this.formGroup.get('subtotalWithFees').setErrors(null);
    }

    this.calculateLoanAmount();
  }

  calculateBrokerage(source) {
    let value = 0;

    if (this.formGroup.get('purchaseRefinanceAmount').value > 0) {
      switch (source) {
        case 'brokerageFeePercentage':
          value = +(((this._subtotal + this._totalFees) * this.formGroup.get('brokerageFeePercentage').value) / 100).toFixed(2);

          this._brokerageUpdated = true;
          this.formGroup.get('brokerageFee').patchValue(value);
          break;

        case 'brokerageFee':
          value = +((this.formGroup.get('brokerageFee').value / (this._subtotal + this._totalFees)) * 100).toFixed(5);

          this._brokerageUpdated = true;
          this.formGroup.get('brokerageFeePercentage').patchValue(value);
          break;
      }

      this.calculateLoanAmount();
    }
  }

  calculateLoanAmount() {
    const brokerage = this.formGroup.get('brokerageFee').value || 0;
    this.totalLoanAmount = +(this._subtotal + this._totalFees);

    if (!this.dialDownEnabled) {
      this.totalLoanAmount = this.totalLoanAmount + Number(this.formGroup.get('brokerageFee').value);
    }
    this.formGroup.get('totalLoanAmount').patchValue(this.totalLoanAmount.toFixed(2));

    this.rateService.setRateParameters({
      depositAmount: +(this.formGroup.value.depositTradeAmount) + +(this.formGroup.value.amountPaid) || 0,
      originationFee: this.formGroup.value.originationFee || 0,
      totalLoanAmount: +(this.formGroup.value.purchaseRefinanceAmount) || 0,
      capitalisedPurposes: this._totalInsurance || 0,
      brokerage: brokerage,
      applicationFee: +(this.formGroup.get('applicationFee').value),
    });
    this.dataHandlerService.sendAutoLoanAmountData(this.totalLoanAmount);
  }

  initInsurance() {
    if (this.insurancesFormArray.length === 0) {
      const fg = this.formBuilderService.convertObjectToFormGroup(new InvidualInsuranceModel());
      this.formBuilderService.setValidationRules(new InvidualInsuranceModel(), fg);
      this.insurancesFormArray.push(fg);
    }
  }

  handleInsurancesChange(event) {
    this._totalInsurance = event || 0;
    this.calculateSubtotalAndFees();
  }
}
